import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import DeleteForever from '@material-ui/icons/DeleteForever';
import EditIcon from "@material-ui/icons/Edit";
import moment from 'moment'
import TableGeneric from "../../compartidos/abms/TableGeneric";
import { ModulosContratacionesForm } from "./ModulosContratacionesForm";
import { eliminarModuloPorEfectorFacturacion, generateExcelModulosPorEfectorFacturacion, generatePDFModulosPorEfectorFacturacion, guardarModuloPorEfectorFacturacion } from "../../../actions/contrataciones/contratacionesModulos";
import ToolbarXLSPDF from "../../compartidos/ToolbarXLSPDF";
import { useReactToPrint } from "react-to-print";

const RenderEditButton = ({ item }) => {
  const dispatch = useDispatch();

  const [openEdit, setOpenEdit] = useState(false)
  return (
    <strong>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{ marginLeft: 16 }}
        onClick={() => {
          setOpenEdit(true)
        }}
      >
        <EditIcon />
      </Button>

      {
        openEdit && (
          <Dialog
            open={openEdit}
            onClose={(e) => setOpenEdit(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            fullWidth
            maxWidth="lg"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Guardar Prestador"}
            </DialogTitle>
            <DialogContent>
              <ModulosContratacionesForm
                formData={item}
                handleSubmit={(data) => {
                  dispatch(
                    guardarModuloPorEfectorFacturacion(
                      data,
                      () => setOpenEdit(false)
                    ))
                }}
                handleCloseModal={() => setOpenEdit(false)}
              />
            </DialogContent>
          </Dialog>
        )
      }
    </strong>
  );
};

const RenderDeleteButton = ({ item }) => {
  const dispatch = useDispatch();
  const [openDelete, setOpenDelete] = useState(false)
  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        size="small"
        style={{ marginLeft: 16 }}
        onClick={(e) => {
          setOpenDelete(true)
        }}
      >
        <DeleteForever />
      </Button>
      {
        openDelete && (
          <Dialog
            open={openDelete}
            onClose={(e) => setOpenDelete(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Eliminar Practicas"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                ¿Desea eliminar las practicas de este modulo?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => {
                  dispatch(
                    eliminarModuloPorEfectorFacturacion(
                      item.idModulo,
                      () => setOpenDelete(false)
                    )
                  );
                }}
                color="primary"
              >
                Aceptar
              </Button>
              <Button
                onClick={(e) => {
                  setOpenDelete(false);
                }}
                color="primary"
              >
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>
        )
      }
    </>
  );
};

export const ModulosTable = ({ disabled }) => {
  const { modulosPorContrato } = useSelector((state) => state.contratacionesModulos);
  const { dataContrato } = useSelector((state) => state.contrataciones);
  const dispatch = useDispatch()
  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <>
      <Grid container justify="flex-end" style={{ marginTop: "3rem" }}>
        <Grid item >
          <ToolbarXLSPDF
            handlePrint={handlePrint}
            handleExportExcel={() => dispatch(generateExcelModulosPorEfectorFacturacion(dataContrato.idEfectorFacturacion))}
            handleGeneratePdf={() => dispatch(generatePDFModulosPorEfectorFacturacion(dataContrato.idEfectorFacturacion))}
          />
        </Grid>
      </Grid>
      <TableGeneric
        ref={componentRef}
        data={modulosPorContrato}
        columns={[
          {
            label: "Codigo Modulo",
            id: "codigo",
            sort: true
          },
          {
            label: "Nombre Modulo",
            id: "descripcion",
            sort: true
          },
          {
            label: "Fecha Baja",
            id: "fechaBaja",
            sort: true,
            customBody: (item) => item.fechaBaja ? moment(item.fechaBaja).format('DD/MM/YYYY') : ""
          },
          {
            label: "Practicas",
            id: "practicas",
            customBody: (item) =>
              <div>
                {
                  item.practicas.map((practica, index) => (
                    <p key={index} style={{ marginTop: 0, marginBottom: 5 }}>{`${practica.codigoPractica} - ${practica.nombrePractica} `} {practica.fechaBaja && <span style={{ fontWeight: "bold" }}>{`- Fecha Baja: ${moment(practica.fechaBaja).format("DD/MM/YYYY")}`}</span>}</p>
                  ))
                }
              </div>,
          },
          {
            label: "Acciones",
            id: "",
            customBody: (item) => !disabled && item.fechaBaja === null &&
              <>
                <RenderEditButton item={item} />
                <RenderDeleteButton item={item} />
              </>
          }
        ]}
      />
    </>
  );
};
